import { DatePipe } from "@angular/common";
import moment from "moment";

export default class DateTimeHelper {
  static formatHours(num: number, size: number): string {
    // Normalize the hour to a valid 24-hour clock value (0-23).
    num = num % 24
    let numString = num.toString();
    while (numString.length < size) {
      numString = '0' + num;
    }
    return numString;
  }

  static getInAnHour(): Date {
    const milliseconds = 0;
    const sec = 0;
    const min = 0;
    const hours = 1;
    const days = 0;

    const startDate = new Date();

    const newDate = new Date(
      startDate.getTime() +
      milliseconds +
      1000 * (sec + 60 * (min + 60 * (hours + 24 * days)))
    );
    return newDate;
  }

    static addTimeToDate(date: Date | null, time: string | null): Date | null {
        if (date) {
            const newDate: Date = new Date(date);

            if (time) {
                const parts = time.split(':');
                const hours = Number(parts[0]);
                const minutes = Number(parts[1]);

                newDate.setHours(hours, minutes, 0, 0);
            }

            return newDate;
        }

        return null;
    }

  static getTimeFromDate(datePipe: DatePipe, date: Date | null): string | null {
    return datePipe.transform(date, 'HH:mm');
  }

  static getDateOnly(date: Date): Date {
    return new Date(date.toDateString());
    }

  static getWeekDay(date: Date): string {
    const dayIndex = new Date(date).getDay();
    const days = ['Common.Sunday', 'Common.Monday', 'Common.Tuesday', 'Common.Wednesday', 'Common.Thursday', 'Common.Friday', 'Common.Saturday'];
    const dayName = days[dayIndex];
    return dayName;
  }

  static getlocalDateOnlyFromUTC(date: Date): Date {
    const result = new Date(date);
    result.setHours(0);
    result.setMinutes(0);

    return result;
  }

  static addYears(date: Date, years: number): Date {
    let result = new Date(date);
    result.setFullYear(date.getFullYear() + years);

    return result
  }

  static addDays(date: Date, days: number): Date {
    let result = new Date(date);
    result.setDate(result.getDate() + days);

    return result;
  }

  static addMonths(date: Date, months: number): Date {
    let result = new Date(date);
    result.setMonth(date.getMonth() + months);

    return result;
  }

  static addHours(date: Date, hours: number): Date {
    let result = new Date(date);
    result.setHours(date.getHours() + hours);

    return result;
  }

  static addMinutes(date: Date, minutes: number): Date {
    let result = new Date(date);
    result.setMinutes(date.getMinutes() + minutes);

    return result;
  }

  static getFirstDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  static getLastDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  static getFirstDayOfYear(date: Date): Date {
    return new Date(date.getFullYear(), 0, 1, 0, 0, 0);
  }

  static getLastDayOfYear(date: Date): Date {
    return new Date(date.getFullYear(), 11, 31, 0, 0, 0);
  }

  static getDateFromMomentOrDate(date: any): Date {
    if (date instanceof moment) {
      return moment(date).toDate();
    }

    // Could also be a string
    return new Date(date);
  }

  static getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  static getStartOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  static getDateOrDefault(value: Date | string | null): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof moment) {
      return moment(value).toDate();
    }

    return new Date(value);
  }

  public static isDateString(value) {
    if (value === null || value === undefined || typeof value !== 'string') {
      return false;
    }

    const regex = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/;

    return regex.test(value);
  }

  public static isMoreThanOneWeek(startDate: Date | null | undefined,
    endDate: Date | null | undefined): boolean {

    if (!startDate || !endDate) return false;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffMs = end.getTime() - start.getTime();
    const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

    return diffMs > oneWeekMs;
  }

  private static formatHHMM(date: Date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  public static getTimeHHMM(date: Date) {
    if (!date) return '';

    // If already a Date, use it
    if (date instanceof Date) {
      return this.formatHHMM(date);
    }

    const d = new Date(date);
    if (!isNaN(d.getTime())) {
      return this.formatHHMM(d);
    }

    // Invalid input → return empty
    return '';
    }

    public static toISOStringWithOffset(date: Date): string {
        const timeZoneOffset = -date.getTimezoneOffset();
        const sign = timeZoneOffset >= 0 ? '+' : '-';
        const pad = function (num: number) {
            return (num < 10 ? '0' : '') + num;
        };

        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            sign + pad(Math.floor(Math.abs(timeZoneOffset) / 60)) +
            ':' + pad(Math.abs(timeZoneOffset) % 60);
    }

}
